/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Input, Button, Switch, message, Card, Row, Col } from 'antd';
import { insuranceCompanyService } from '../../../services/insuranceService';
import Breadcrumb from '../../../components/ui/Breadcrumb';

const AddInsuranceCompany = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const companyId = searchParams.get('id');
  const isEdit = Boolean(companyId);

  useEffect(() => {
    if (isEdit) {
      loadCompany();
    }
  }, [isEdit, companyId]);

  const loadCompany = async () => {
    try {
      const company = await insuranceCompanyService.getById(parseInt(companyId));
      form.setFieldsValue({
        name: company.name,
        code: company.code,
        description: company.description,
        phone: company.phone,
        email: company.email,
        address: company.address,
        is_active: company.is_active
      });
    } catch (error) {
      message.error('Error al cargar aseguradora');
      navigate('/insurance-companies');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await insuranceCompanyService.update(parseInt(companyId), values);
        message.success('Aseguradora actualizada correctamente');
      } else {
        await insuranceCompanyService.create(values);
        message.success('Aseguradora creada correctamente');
      }
      navigate('/insurance-companies');
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Error al guardar aseguradora';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">{isEdit ? 'Editar' : 'Agregar'} Aseguradora</h3>
                <Breadcrumb items={[{ label: 'Inicio', to: '/' }, { label: 'Aseguradoras', to: '/insurance-companies' }, { label: isEdit ? 'Editar' : 'Agregar' }]} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Card>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  initialValues={{
                    is_active: true
                  }}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Nombre"
                        name="name"
                        rules={[{ required: true, message: 'El nombre es requerido' }]}
                      >
                        <Input placeholder="Nombre de la aseguradora" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Código"
                        name="code"
                        rules={[{ required: true, message: 'El código es requerido' }]}
                      >
                        <Input placeholder="Código único" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label="Teléfono"
                        name="phone"
                      >
                        <Input placeholder="Teléfono de contacto" />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ type: 'email', message: 'Ingrese un email válido' }]}
                      >
                        <Input placeholder="Email de contacto" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    label="Dirección"
                    name="address"
                  >
                    <Input.TextArea rows={2} placeholder="Dirección de la aseguradora" />
                  </Form.Item>

                  <Form.Item
                    label="Descripción"
                    name="description"
                  >
                    <Input.TextArea rows={3} placeholder="Descripción adicional" />
                  </Form.Item>

                  <Form.Item
                    label="Estado"
                    name="is_active"
                    valuePropName="checked"
                  >
                    <Switch checkedChildren="Activo" unCheckedChildren="Inactivo" />
                  </Form.Item>

                  <Form.Item className="text-end">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      className="me-2"
                    >
                      {isEdit ? 'Actualizar' : 'Guardar'}
                    </Button>
                    <Button onClick={() => navigate('/insurance-companies')}>
                      Cancelar
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
    </>
  );
};

export default AddInsuranceCompany;
